export default __webpack_public_path__ + "static/media/rozbudowa3.465e024b.svg";